<div class="modal-overlay" *ngIf="showModal">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div>
        <h2>Add New Address</h2>
        <p class="customer-info" *ngIf="customerId || customer?.customerId">
          Customer ID: {{ customerId || customer?.customerId }}
        </p>
      </div>
      <button class="close-btn" (click)="onCancel()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <form [formGroup]="addressForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="address">Address *</label>
          <textarea 
            id="address"
            formControlName="address"
            placeholder="Enter complete address"
            rows="3"
            class="form-control"
            [class.invalid]="addressForm.get('address')?.invalid && addressForm.get('address')?.touched">
          </textarea>
          <div class="error-message" *ngIf="addressForm.get('address')?.invalid && addressForm.get('address')?.touched">
            <span *ngIf="addressForm.get('address')?.errors?.['required']">Address is required</span>
            <span *ngIf="addressForm.get('address')?.errors?.['minlength']">Address must be at least 10 characters</span>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="pincode">Pincode *</label>
            <input 
              type="text" 
              id="pincode"
              formControlName="pincode"
              placeholder="Enter 6-digit pincode"
              class="form-control"
              maxlength="6"
              [class.invalid]="addressForm.get('pincode')?.invalid && addressForm.get('pincode')?.touched">
            <div class="error-message" *ngIf="addressForm.get('pincode')?.invalid && addressForm.get('pincode')?.touched">
              <span *ngIf="addressForm.get('pincode')?.errors?.['required']">Pincode is required</span>
              <span *ngIf="addressForm.get('pincode')?.errors?.['pattern']">Please enter a valid 6-digit pincode</span>
            </div>
          </div>

          <div class="form-group">
            <label for="locationName">Location Name *</label>
            <input 
              type="text" 
              id="locationName"
              formControlName="locationName"
              placeholder="e.g., Home, Office, etc."
              class="form-control"
              [class.invalid]="addressForm.get('locationName')?.invalid && addressForm.get('locationName')?.touched">
            <div class="error-message" *ngIf="addressForm.get('locationName')?.invalid && addressForm.get('locationName')?.touched">
              <span *ngIf="addressForm.get('locationName')?.errors?.['required']">Location name is required</span>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="latitude">Latitude *</label>
            <input 
              type="number" 
              id="latitude"
              formControlName="latitude"
              placeholder="Enter latitude"
              class="form-control"
              step="any"
              [class.invalid]="addressForm.get('latitude')?.invalid && addressForm.get('latitude')?.touched">
            <div class="error-message" *ngIf="addressForm.get('latitude')?.invalid && addressForm.get('latitude')?.touched">
              <span *ngIf="addressForm.get('latitude')?.errors?.['required']">Latitude is required</span>
            </div>
          </div>

          <div class="form-group">
            <label for="longitude">Longitude *</label>
            <input 
              type="number" 
              id="longitude"
              formControlName="longitude"
              placeholder="Enter longitude"
              class="form-control"
              step="any"
              [class.invalid]="addressForm.get('longitude')?.invalid && addressForm.get('longitude')?.touched">
            <div class="error-message" *ngIf="addressForm.get('longitude')?.invalid && addressForm.get('longitude')?.touched">
              <span *ngIf="addressForm.get('longitude')?.errors?.['required']">Longitude is required</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="addressType">Address Type</label>
          <select 
            id="addressType"
            formControlName="addressType"
            class="form-control">
            <option value="">-- Select Address Type (Optional) --</option>
            <option value="Home">Home</option>
            <option value="Office">Office</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div class="form-group checkbox-group">
          <label class="checkbox-label">
            <input 
              type="checkbox" 
              formControlName="isPrimary"
              class="checkbox-input">
            <span class="checkmark"></span>
            Set as primary address
          </label>
          <small class="help-text">If checked, this will become the customer's primary address</small>
        </div>

        <div class="error-message global-error" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <div class="modal-actions">
          <button 
            type="button" 
            class="btn btn-secondary" 
            (click)="onCancel()"
            [disabled]="isLoading">
            Cancel
          </button>
          <button 
            type="submit" 
            class="btn btn-primary" 
            [disabled]="addressForm.invalid || isLoading">
            <span *ngIf="isLoading" class="loading-spinner"></span>
            {{ isLoading ? 'Adding...' : 'Add Address' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
